import { defineMessages } from 'react-intl';

export default defineMessages({
    seeRepaymentBreakdown: {
        id: '_.status_lines.see_repayment_breakdown',
        defaultMessage: 'Click here to see your repayment breakdown'
    },
    seeRepaymentSchedule: {
        id: '_.status_lines.see_repayment_schedule',
        defaultMessage: 'See repayment schedule'
    }
});
